import React, { useMemo } from 'react';
import { Flex, Pane, Text } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import Detail from '../../views/salesFlow/components/Detail';
import S from '../../views/salesFlow/components/CardStyle.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t
} = I18N.ns('recovr.sale.addAdditionalTagsToSale');
export default function TagInfoCard(props) {
  const {
    keys,
    keysSalesPrice,
    sale,
    additionalTagData
  } = props;
  const taggedKeys = Object.entries(additionalTagData).reduce((prev, [key, keyData]) => {
    if (keyData.sell) {
      prev[key] = keyData;
    }
    return prev;
  }, {});
  const tagLabel = useMemo(() => {
    const numKeys = Object.keys(taggedKeys).length;
    if (numKeys > 1) {
      return `${numKeys} RecovR Tags will be added to this sale.`;
    }
    return '1 RecovR Tag will be added to this sale.';
  }, [keys]);
  return /*#__PURE__*/_jsxs(Pane, {
    variant: "dashboardCard",
    layout: "flex:col",
    className: S.container,
    children: [/*#__PURE__*/_jsxs(Pane, {
      layout: "flex:colL",
      variant: "keysDataCardUpper",
      children: [/*#__PURE__*/_jsxs(Flex, {
        variant: "rowL",
        align: "center",
        children: [/*#__PURE__*/_jsx("img", {
          width: 80,
          height: 80,
          alt: "RecovR Tag",
          src: "https://storage.googleapis.com/recovr-ui-assets/recovr-tag.png"
        }), /*#__PURE__*/_jsxs(Flex, {
          variant: "colM",
          children: [/*#__PURE__*/_jsx(Text, {
            variant: "bodySmallBold",
            children: tagLabel
          }), /*#__PURE__*/_jsxs(Text, {
            variant: "bodySmall",
            children: ["In total, ", Object.keys(taggedKeys).length + Object.keys(keys).length, " ", t('tagAddedText')]
          })]
        })]
      }), keysSalesPrice != null && /*#__PURE__*/_jsxs(Flex, {
        direction: "row",
        justify: "space-between",
        children: [/*#__PURE__*/_jsx(Text, {
          variant: "bodySmall",
          children: "RecovR Tags Sales Price"
        }), /*#__PURE__*/_jsxs(Text, {
          variant: "bodySmallBold",
          children: ["$", keysSalesPrice]
        })]
      })]
    }), /*#__PURE__*/_jsxs(Text, {
      style: {
        marginLeft: 10,
        marginTop: 10
      },
      variant: "bodySmallBold",
      children: [t('existingTagTitle'), " (", Object.keys(keys).length, ")"]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        margin: 10
      },
      children: Object.keys(keys).length > 0 && /*#__PURE__*/_jsx(Pane, {
        variant: "dashboardCard",
        children: /*#__PURE__*/_jsx(Pane, {
          variant: "dataCard",
          children: Object.entries(keys).map(([key, value]) => {
            return /*#__PURE__*/_jsx(Detail, {
              label: value.key?.data?.keyId || value.key?.data?.notes || 'Key Id Pending',
              value: sale?.data?.data?.keys[key].tagSerialNumber
            }, key);
          })
        })
      })
    }), /*#__PURE__*/_jsxs(Text, {
      style: {
        marginLeft: 10
      },
      variant: "bodySmallBold",
      children: [t('tagToBeAddedTitle'), " (", Object.keys(taggedKeys).length, ")"]
    }), /*#__PURE__*/_jsx("div", {
      style: {
        margin: 10
      },
      children: /*#__PURE__*/_jsx(Pane, {
        variant: "dashboardCard",
        children: /*#__PURE__*/_jsx(Pane, {
          variant: "dataCard",
          children: /*#__PURE__*/_jsx(Pane, {
            layout: "flex:colS",
            children: Object.entries(taggedKeys).map(([key, value]) => {
              return /*#__PURE__*/_jsx(Detail, {
                label: value.key?.data?.keyId || value.key?.data?.notes || 'Key Id Pending',
                value: value?.tagSerial
              }, key);
            })
          })
        })
      })
    })]
  });
}